export const MIN_ITEMS_PER_CATEGORY_TO_SHOW = 25;
